import "./App.css";
import MainModels from "./main/MainModels";
import { DataProvider } from "./context/Context"; // Import the context provider
import Index from "./main/Index";
import Routes from "./Routes/Index";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="App">
      <DataProvider>
        <Toaster position="top-center" reverseOrder={false} />
        <Routes />
      </DataProvider>
    </div>
  );
}

export default App;
